<template>
    <div id="content">
        <div class="large-empty bakim">
            <i class="fa fa-tools fa-3x"></i>
            <span>pediatrim.net şu an bakımda. Daha sonra tekrar deneyin</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Bakim",
    data() {
        return {};
    },
    created() {},
};
</script>

<style lang="scss">
.bakim span,
.bakim svg,
.bakim a {
    color: white !important;
}
.bakim a {
    text-decoration: underline;
}
</style>